import "core-js/stable";
import "regenerator-runtime/runtime";
import 'bootstrap';
import AOS from 'aos';
import '../scss/app.scss';
import Inputmask from "inputmask";
import { fixeButton } from "./fixeButton";

const styleRoot = document.querySelector(":root");

var viewPaper = false;
var viewTree = false;
var viewWater = false;
var viewPool = false;

window.RDCookieControl = { configuration: null };

window.addEventListener('load', () => {

  loadingOverlay(true);
  loadData();

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('sw.js').then(() => {
      console.log('Service worker registered!');
    }).catch((error) => {
      console.warn('Error registering service worker:');
      console.warn(error);
    });
  }

  var animationProfelix = bodymovin.loadAnimation({
    container: document.getElementById('pill-profelix'),
    path: 'images/MevoPills_Profelix.json',
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "MevoPillsProfelix",
  });

  var animationProfelix = bodymovin.loadAnimation({
    container: document.getElementById('pill-tranquilax'),
    path: 'images/MevoPills_Tranquilax.json',
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "MevoPillsTranquilax",
  });

  var animationProfelix = bodymovin.loadAnimation({
    container: document.getElementById('alegril-pill'),
    path: 'images/MevoPills_Alegril.json',
    renderer: 'svg',
    loop: true,
    autoplay: true,
    name: "MevoPillsAlegril",
  });

});

const startAPP = (kilos_papel, arvores_poupadas, litros_poupados, piscinas_olimpicas) => {

  AOS.init();

  fixeButton();

  phoneMask();

  calculatorForm();

  window.addEventListener('scroll', function (event) {
    listenerScroll(event, kilos_papel, arvores_poupadas, litros_poupados, piscinas_olimpicas);
  });

  let main = document.querySelector('main');
  let footer = document.querySelector('footer');

  main.classList.remove('d-none');
  footer.classList.remove('d-none');

  loadingOverlay(false);

}

const loadData = () => {

  let data = getLocalStorageData();

  if (data) {

    let now = new Date();
    let data_expiracao = new Date(data.data_expiracao);
    let kilos_papel = parseInt(data.kilos_papel);
    let arvores_poupadas = parseInt(data.arvores_poupadas);
    let litros_poupados = parseInt(data.litros_poupados);
    let piscinas_olimpicas = parseInt(data.piscinas_olimpicas);

    let dateDiff = DateDiff.inDays(now, data_expiracao);

    if (dateDiff < 0) {
      getNumberFromMevoAPI();
      return;
    }

    startAPP(kilos_papel, arvores_poupadas, litros_poupados, piscinas_olimpicas);

    return;

  }

  getNumberFromMevoAPI();

}

const loadingOverlay = (action) => {

  let HTML = document.querySelector('html');

  if (action) {

    HTML.style.overflow = 'hidden';

    let loading = document.createElement('img');
    loading.setAttribute('src', './images/loader.svg');

    let overlay = document.createElement('div');
    overlay.setAttribute('id', 'overlay');
    overlay.appendChild(loading);

    document.body.insertBefore(overlay, document.body.firstChild);

    return;

  }

  let overlayObj = document.getElementById('overlay');
  overlayObj.classList.add('class', 'overlay-hide');

  setTimeout(() => {

    overlayObj.remove();

    HTML.style.overflowY = 'scroll';

  }, 1000);

}

const setLocalStorageData = (data_expiracao, kilos_papel, arvores_poupadas, litros_poupados, piscinas_olimpicas) => {

  let data = JSON.parse(`{"data_expiracao":"${data_expiracao}", "kilos_papel":"${kilos_papel}","arvores_poupadas":"${arvores_poupadas}", "litros_poupados":"${litros_poupados}", "piscinas_olimpicas":"${piscinas_olimpicas}"}`);

  localStorage.setItem('mevo-data', JSON.stringify(data));

  return data;

}

const getLocalStorageData = () => {
  let data = JSON.parse(localStorage.getItem('mevo-data'));
  return data;
}

const weekDay = () => {
  const date = new Date();
  let day = date.getDay();
  return day;
};

const getNumberFromMevoAPI = async event => {

  let json_data = '{"parceiro": "all", "subparceiro": "gndi"}';

  try {

    await fetch(`https://papelometroapi.mevosaude.com.br/data`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'parceiro':'all',
        'subparceiro': 'gndi',
      },
      body: json_data,
    })
      .then((response) => response.json())
      .then(function (data) {

        let date_to_expire = 7 - weekDay();
        let date = new Date();

        let data_expiracao = date.addDays(date_to_expire);
        let kilos_papel = data.kilos_papel;
        let arvores_poupadas = data.arvores_poupadas;
        let litros_poupados = data.litros_poupados;
        let piscinas_olimpicas = data.piscinas_olimpicas;

        setLocalStorageData(data_expiracao, kilos_papel, arvores_poupadas, litros_poupados, piscinas_olimpicas);

        startAPP(kilos_papel, arvores_poupadas, litros_poupados, piscinas_olimpicas);

      })
      .catch(err => console.log(err));


  } catch (error) {
    console.log(error);
  }
};

const listenerScroll = (event, kilos_papel, arvores_poupadas, litros_poupados, piscinas_olimpicas) => {

  let currentPosition = (document.body.getBoundingClientRect()).top;
  let windowWidth = window.screen.width;

  let paperStart = -530;
  let treeStart = -1700;
  let waterStart = -2800;
  let poolStart = -3900;

  if (windowWidth < 992) {
    paperStart = -100;
    treeStart = -625;
    waterStart = -1195;
    poolStart = -1740;
  }

  if (currentPosition <= paperStart && viewPaper == false) {
    viewPaper = true;
    let kgPaperTotal = String((kilos_papel).toLocaleString('pt-BR'));
    startSetNumbers(kgPaperTotal, '.total-paper', 'paper');
  }

  if (currentPosition <= treeStart && viewTree == false) {
    viewTree = true;
    let treesTotal = String((arvores_poupadas).toLocaleString('pt-BR'));
    startSetNumbers(treesTotal, '.total-trees', 'tree');
  }

  if (currentPosition <= waterStart && viewWater == false) {
    viewWater = true;
    let literWaterTotal = String((litros_poupados).toLocaleString('pt-BR'));
    startSetNumbers(literWaterTotal, '.total-water', 'water');
  }

  if (currentPosition <= poolStart && viewPool == false) {
    viewPool = true;
    let poolsTotal = String((piscinas_olimpicas).toLocaleString('pt-BR'));;
    startSetNumbers(poolsTotal, '.total-pools', 'pool');
  }

}

const calculatorForm = () => {

  const form = document.getElementById("form-calculator");

  form.addEventListener("submit", function (event) {

    event.preventDefault();

    const bt = document.getElementById("btn-send");
    bt.innerHTML = "Enviando..."
    bt.disabled = true;

    const prescriptionsWeight = 6.25;
    const TOKEN = '86e8b1620a02f84dded3f462e927328e';
    const identificador = 'papelometro';

    const name = document.getElementById('name').value;
    const company = document.getElementById('company').value;
    const email = document.getElementById('email').value;
    const phone = document.getElementById('phone').value;
    const authorization = document.getElementById('authorization').value;
    const totalDoctors = document.getElementById("total_doctors").value;
    const totalPatients = document.getElementById("total_patients").value;

    const data_array = [
      { name: 'name', value: name },
      { name: 'company', value: company },
      { name: 'email', value: email },
      { name: 'phone', value: phone },
      { name: 'authorization', value: authorization },
      { name: 'identificador', value: identificador },
      { name: 'token_rdstation', value: TOKEN },
    ];

    //Atenção fazer validações

    RdIntegration.post(data_array, function (data) {
      //Tratar retorno
      console.log(arguments);
    });

    let prescriptions = totalDoctors * totalPatients;
    let kgDay = (prescriptions * prescriptionsWeight) / 1000;
    let literDay = prescriptions * 10;
    let kgYear = (Math.round(kgDay * 365)).toLocaleString('pt-BR');
    let literYear = (Math.round(literDay * 365)).toLocaleString('pt-BR');

    let result = `<h2 id="title-papelometro-result" class="text-center mx-auto mb-0 text-purple">Seu hospital poderia ter economizado:</h2>
                  <div class="my-5 numbers-wrapper total-paper-year"></div>
                  <p class="kg-papel text-purple" data-aos="zoom-in-up" data-aos-duration="2000">Kg de papel ao ano</p>
                  <hr />
                  <h2 class="text-center mx-auto text-purple">Ou ainda:</h2>
                  <div class="my-5 numbers-wrapper total-water-year"></div>
                  <p class="water text-purple" data-aos="zoom-in-up" data-aos-duration="2000">Litros de água por ano</p>
                  `;

    form.insertAdjacentHTML('afterend', result);

    kgYear = String((kgYear).toLocaleString('pt-BR'));
    startSetNumbers(kgYear, '.total-paper-year', 'paperyear');

    literYear = String((literYear).toLocaleString('pt-BR'));;
    startSetNumbers(literYear, '.total-water-year', 'wateryear');

    form.style.display = "none";

    document.getElementById("title-papelometro-result").scrollIntoView(1);

  });

}

const phoneMask = () => {

  let phoneInput = document.getElementById("phone");

  phoneInput.addEventListener("focusout", (event) => {

    const phone = phoneInput.value.replace(/\D/g, '');

    if (phoneInput.inputmask) {
      phoneInput.inputmask.remove();
    }

    if (phone.length > 10) {

      let im = new Inputmask("(99) 99999-9999");
      im.mask(phoneInput);

    } else {

      let im = new Inputmask("(99) 9999-9999");
      im.mask(phoneInput);

    }

  });

  phoneInput.addEventListener("focusin", (event) => {

    if (phoneInput.inputmask) {
      phoneInput.inputmask.remove();
    }

    let im = new Inputmask("(99) 99999-9999");
    im.mask(phoneInput);

  });

}

const startSetNumbers = (total, container, type) => {

  if (!total) {
    //O que acontece se não retornar nada da API?
    return false;
  }

  const targetContainer = document.querySelector(container);

  total = Array.from(total);

  for (let i in total) {

    let point = "";
    let numberZero = "0";
    let numberOne = "1";
    let numberTwo = "2";
    let numberThree = "3";
    let numberFour = "4";
    let numberFive = "5";
    let numberSix = "6";
    let numberSeven = "7";
    let numberEight = "8";
    let numberNine = "9";
    let numberTen = ".";

    if (total[i] == ".") {
      point = 'class="point"';
      numberZero = "";
      numberOne = "";
      numberTwo = "";
      numberThree = "";
      numberFour = "";
      numberFive = "";
      numberSix = "";
      numberSeven = "";
      numberEight = "";
      numberNine = "";
      numberTen = ".";
    }

    let calcYear = "";

    if (type == 'paperyear' || type == 'wateryear') {
      if (!point) {
        calcYear = 'class="bgPinkLingh"'
      }
    }

    const template = `<div class="nums ${type}-nums">
                        <span ${calcYear} ${point}>${numberZero}</span>
                        <span ${calcYear} ${point}>${numberOne}</span>
                        <span ${calcYear} ${point}>${numberTwo}</span>
                        <span ${calcYear} ${point}>${numberThree}</span>
                        <span ${calcYear} ${point}>${numberFour}</span>
                        <span ${calcYear} ${point}>${numberFive}</span>
                        <span ${calcYear} ${point}>${numberSix}</span>
                        <span ${calcYear} ${point}>${numberSeven}</span>
                        <span ${calcYear} ${point}>${numberEight}</span>
                        <span ${calcYear} ${point}>${numberNine}</span>
                        <span ${calcYear} ${point}>${numberTen}</span>
                      </div>`;

    targetContainer.insertAdjacentHTML('beforeend', template);

  }

  setNumberPercent(Array.from("00000"), type);

  setTimeout(() => {
    setNumberPercent(total, type);
  }, 1000);

}

const setNumberPercent = (numbers, type) => {

  let numberBottom;
  let windowWidth = window.screen.width;

  for (let i in numbers) {
    switch (numbers[i]) {
      case "0":
        numberBottom = "508%";
        if (windowWidth < 992) {
          numberBottom = "512%";
        }
        break;
      case "1":
        numberBottom = "410%";
        break;
      case "2":
        numberBottom = "306%";
        break;
      case "3":
        numberBottom = "205%";
        break;
      case "4":
        numberBottom = "102%";
        break;
      case "5":
        numberBottom = "0%";
        break;
      case "6":
        numberBottom = "-102%";
        break;
      case "7":
        numberBottom = "-205%";
        break;
      case "8":
        numberBottom = "-306%";
        break;
      case "9":
        numberBottom = "-410%";
        break;
      case ".":
        numberBottom = "-510%";
        break;
    }

    styleRoot.style.setProperty(`--${type}-bottom-${i}`, numberBottom);
  }
}

const DateDiff = {

  inDays: function (d1, d2) {
    var t2 = d2.getTime();
    var t1 = d1.getTime();

    return Math.floor((t2 - t1) / (24 * 3600 * 1000));
  },

  inWeeks: function (d1, d2) {
    var t2 = d2.getTime();
    var t1 = d1.getTime();

    return parseInt((t2 - t1) / (24 * 3600 * 1000 * 7));
  },

  inMonths: function (d1, d2) {
    var d1Y = d1.getFullYear();
    var d2Y = d2.getFullYear();
    var d1M = d1.getMonth();
    var d2M = d2.getMonth();

    return (d2M + 12 * d2Y) - (d1M + 12 * d1Y);
  },

  inYears: function (d1, d2) {
    return d2.getFullYear() - d1.getFullYear();
  }
}

Date.prototype.addDays = function (days) {
  const date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};